export default __webpack_public_path__ + "boundaries-sample-960-c259e0bda253b9bff49d19915c393a1e.png";